module.exports = __webpack_public_path__ + "img/four4Orange.7db04250.jpg";